<template>
  <div class="socials-form">
    <KycDropdown
      title="Socials"
      subTitle="Fill in social media details"
      :status="orgDetails.tokens?.length ? true : false"
      :edit="''"
      @active-dropdown="setDropdownStatus"
    >
      <template v-slot:content>
        <form @submit.prevent="submitSocials" class="form-content">
          <div class="form-grid">
            <div class="form-group">
              <TextInput
                placeHolder="https://yourwebsite.com"
                label="Website"
                type="text"
                fieldType="url"
                name="website"
                id="website"
                :showLabel="true"
                :url="socialPayload.website"
                @set="setWebsite"
                @valid="websiteValid"
              />
            </div>
            <div class="form-group">
              <TextInput
                placeHolder="https://facebook.com/yourpage"
                label="Facebook"
                type="text"
                fieldType="url"
                name="facebook"
                id="facebook"
                :showLabel="true"
                :required="false"
                :url="socialPayload.facebook"
                @set="setFacebook"
                @valid="facebookValid"
              />
            </div>
            <div class="form-group">
              <TextInput
                placeHolder="https://twitter.com/yourhandle"
                label="Twitter"
                type="text"
                fieldType="url"
                name="twitter"
                id="twitter"
                :showLabel="true"
                :required="false"
                :url="socialPayload.twitter"
                @set="setTwitter"
                @valid="twitterValid"
              />
            </div>
            <div class="form-group">
              <TextInput
                placeHolder="https://linkedin.com/company/yourcompany"
                label="LinkedIn"
                type="text"
                fieldType="url"
                name="linkedin"
                id="linkedin"
                :showLabel="true"
                :required="false"
                :url="socialPayload.linkedin"
                @set="setLinkedin"
                @valid="linkedinValid"
              />
            </div>
          </div>

          <div class="form-actions">
            <button type="submit" class="btn-primary" :disabled="socialsLoading">
              <span v-if="socialsLoading" class="btn-loader"></span>
              {{ $route.name === 'EsopDetails' || $route.name === 'ConfigurePrivateRaise' ? 'Save Changes' : 'Continue' }}
            </button>
          </div>
        </form>
      </template>
    </KycDropdown>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import KycDropdown from "@/components/general/KycDropdown.vue";
import TextInput from "@/components/general/TextInput.vue";

export default {
  name: "SocialsForm",

  components: {
    KycDropdown,
    TextInput,
  },

  data() {
    return {
      socialsLoading: false,
      validInput: {
        website: false,
        facebook: false,
        twitter: false,
        linkedin: false,
      },
      socialPayload: {
        website: "",
        facebook: "",
        twitter: "",
        linkedin: "",
      },
    };
  },

  computed: {
    ...mapState({
      orgDetails: (state) => state.organisationModule.organisationDetails,
      assetDetails: (state) => state.assetModule.assetDetails,
    }),
  },

  mounted() {
    this.setSocials();
  },

  methods: {
    ...mapActions("assetModule", ["getAsset", "updateAsset"]),
    ...mapActions(["showToast"]),

    setDropdownStatus(title) {
      this.$emit("dropdown-title", title);
    },

    async submitSocials() {
      if (!this.validInput.website) {
        return this.showToast({
          description: "Please fill input field correctly",
          display: true,
          type: "error",
        });
      }
      this.socialsLoading = true;
      let payload = {
        about: this.assetDetails.about,
        name: this.assetDetails.name,
        type: this.assetDetails.type,
        ...this.socialPayload,
      };
      const response = await this.updateAsset({
        data: payload,
        id: this.$route.query.asset
          ? this.$route.query.asset
          : this.assetDetails._id,
      });
      if (response) {
        // Don't navigate away if on ConfigurePrivateRaise or EsopDetails
        if (this.$route.name === 'ConfigurePrivateRaise' || this.$route.name === 'EsopDetails') {
          this.showToast({
            description: "Socials updated successfully",
            display: true,
            type: "success",
          });
        } else {
          this.$router.push({
            name: "Asset",
            params: { type: this.assetDetails.type || 'equity' },
            query: { id: this.assetDetails._id },
          });
        }
      }
      this.socialsLoading = false;
    },

    setWebsite(val) {
      this.socialPayload.website = val;
    },

    websiteValid(val) {
      this.validInput.website = val;
    },

    setFacebook(val) {
      this.socialPayload.facebook = val;
    },

    facebookValid(val) {
      this.validInput.facebook = val;
    },

    setTwitter(val) {
      this.socialPayload.twitter = val;
    },

    twitterValid(val) {
      this.validInput.twitter = val;
    },

    setLinkedin(val) {
      this.socialPayload.linkedin = val;
    },

    linkedinValid(val) {
      this.validInput.linkedin = val;
    },

    setSocials() {
      if (this.assetDetails?.website) {
        this.socialPayload.website = this.assetDetails.website;
        this.socialPayload.facebook = this.assetDetails.facebook;
        this.socialPayload.twitter = this.assetDetails.twitter;
        this.socialPayload.linkedin = this.assetDetails.linkedin;
        this.validInput = {
          website: true,
          facebook: true,
          twitter: true,
          linkedin: true,
        };
      }
    },
  },

  watch: {
    assetDetails(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.setSocials();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.socials-form {
  .form-content {
    padding: 8px 0;
  }

  .form-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    margin-bottom: 24px;

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }

  .form-group {
    display: flex;
    flex-direction: column;
  }

  .form-actions {
    display: flex;
    justify-content: flex-end;
    padding-top: 16px;
    border-top: 1px solid #E2E8F0;
  }

  .btn-primary {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    height: 44px;
    padding: 0 24px;
    background: #4D84FF;
    border: none;
    border-radius: 8px;
    font-family: 'DM Sans', sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: #FFFFFF;
    cursor: pointer;
    transition: background 0.2s ease;

    &:hover:not(:disabled) {
      background: #3A6FE8;
    }

    &:disabled {
      opacity: 0.7;
      cursor: not-allowed;
    }
  }

  .btn-loader {
    width: 16px;
    height: 16px;
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-top-color: #FFFFFF;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
}
</style>
